/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Agency_Pointone1Inputs */

const ja_home_agency_pointone1 = /** @type {(inputs: Home_Agency_Pointone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームは、異なるカルチャーやバックグラウンドを持つ人々をつなぎ、グローバルなコミュニティを形成する力を持っています。`)
};

const en_home_agency_pointone1 = /** @type {(inputs: Home_Agency_Pointone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This makes games a powerful way to reach people.`)
};

/**
* | output |
* | --- |
* | "This makes games a powerful way to reach people." |
*
* @param {Home_Agency_Pointone1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_agency_pointone1 = /** @type {((inputs?: Home_Agency_Pointone1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Agency_Pointone1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_agency_pointone1(inputs)
	return en_home_agency_pointone1(inputs)
});
export { home_agency_pointone1 as "home_agency_pointOne" }